import * as React from 'react'
import * as Tgcc from '../../tgccGlobal'
import * as Request from '../../tgccRequest'
import { ShopCard } from './ShopCard';
import { CSSProperties } from 'react'
import { ShopAddToCart } from './ShopAddToCart';
import { ShopCart } from './ShopCart';
import { ShopConfirmation } from './ShopConfirmation';
import { ShopItemCloseUp } from './ShopItemCloseup';
import { browserHistory } from 'react-router';

const storeOuterStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    postion: 'fixed',
    top: 0,
    left: 0,
    overflow: 'hidden',
    width: '100%',
    height: '100%'
}
const addBtnStyle: CSSProperties = {
    backgroundColor: '#E27558',
    color: 'black',
    width: '529px',
    height: '49px',
    margin: '15px auto',
    textAlign: 'center',
    lineHeight: '3.2em',
    fontFamily: 'Lulo',
    cursor: 'pointer',
    border: '1px solid transparent',
    ':hover': {
        backgroundColor: 'white',
        color: '#E27558',
        border: '1px solid grey'
    }
}
const storeHeaderStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    zindex: 99
}
const storeCloseBannerStyle: React.CSSProperties = {
    display: 'flex',
    flexAlign: 'stretch',
    justifyContent: 'center',
    background: 'rgba(18,53,121,1)',
    color: 'white',
    fontSize: '18px',
    lineHeight: '35px',
    paddingTop: '5px',
    zindex: 99
}
const storeTitleStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    color: 'White',
    boxShadow: Tgcc.Styles.boxShadow,
    padding: '12px',
    zindex: 99
}
const storeTitleTextStyle: React.CSSProperties = {
    display: 'flex',
    color: 'rgba(66,66,66,1)',
    fontSize: '24px',
    zindex: 99,
    cursor: 'pointer',
    marginLeft:'5px',
    alignItems:'center'
}
const storeTitleLeftStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-begin'
}
const storeTitleRightStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-end'
}
const storeFilterBoxStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-end',
    color: 'rgba(66,66,66,1)',
    fontSize: '16px',
    zindex: 99,
    cursor: 'pointer',
    marginRight: '25px'
}
const storeFilterLabelStyle: React.CSSProperties = {
    lineHeight: '20px',
    marginTop: '4px',
    marginRight: '10px'
}
const storeFilterSelectStyle: React.CSSProperties = {
    paddingTop: '4px',
    paddingLeft: '2px'
}
const storeTitleCartButtonStyle: React.CSSProperties = {
    display: 'flex',
    position: 'relative',
    alignSelf: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: 'white',
    background: 'rgba(66,66,66,1)',
    padding: '10px',
    borderRadius: '5px',
    zindex: 99,
    height: '35px',
    width: '90px'
}
const cartBadgeStyle: React.CSSProperties = {
    position: 'relative',
    top: '-20px',
    right: '0',
    background: 'darkblue',
    color: 'white',
    fontSize: '12px',
    lineHeight: '17px',
    textAlign: 'center',
    borderRadius: '10px',
    padding: '3px',
    height: '20px',
    minWidth: '20px'
}
const cartImageStyle: React.CSSProperties = {
    width: '30px',
    height: '30px',
    marginTop: '-7px',
    marginRight: '8px',
}
const cartTextStyle: React.CSSProperties = {
    lineHeight: '21px',
    fontSize: '14px'
}
const storeDescriptionStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'stretch',
    marginTop: '8px',
    marginLeft: '10px',
    color: 'rgba(67,67,67,1)',
    zindex: 99
}
const storeContentStyle: React.CSSProperties = {
    flexDirection: 'column',
    position: 'relative',
    top: '275px',
    width: '100%',
    overflow: 'hidden auto',
    paddingBottom: '350px'
}

const storeItemGroupStyle: React.CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    width: '100%',
    margin: 'auto'
}
const storeLogo: React.CSSProperties = {
    width: '22%',
    display: 'flex',
    alignSelf: 'center',
    paddingBottom: '10px',
    paddingTop: '10px'
}
const logoStyle: React.CSSProperties = {
    height:'40px'
}
const cartImg = Tgcc.ResolveUrl('~/images/Cart.png');

let errorStyle = Object.assign({}, Tgcc.Styles.error, { fontSize: '20px', marginBottom: '5px' });

class StateType {
    isWaiting: boolean;
    error: string;
    webStore: Tgcc.WebStore;
    itemToAdd: string;
    itemCloseUp: string;
    cart: Tgcc.WebStoreCart;
    showCart: boolean;
    showConfirmEmail: string;
    filterList: string[];
    activeFilter: string;
}

export class Shop extends React.Component<Tgcc.BaseProps, any>{

    state: StateType;

    getEmptyState = () => {
        var emptyState: StateType = {
            isWaiting: true,
            error: null,
            webStore: null,
            itemToAdd: null,
            itemCloseUp: null,
            showCart: false,
            showConfirmEmail: null,
            filterList: null,
            activeFilter: null,
            cart: {
                webStoreId: this.props.params.webStoreID,
                items: []
            }
        };
        return emptyState;
    }

    // use string insensitive comparison
    hostIsShopTheCow = () => 'shopthecow.com'.localeCompare(location.hostname, undefined, { sensitivity: 'accent' }) == 0;

    componentWillMount() {
        this.state = this.getEmptyState();
        var webStoreId = this.props.params.webStoreId
        if (webStoreId) {
            Request.getWebStore(webStoreId, this.onWebStoreLoaded, this.loadError);
        } else if (this.props.params.splat && this.hostIsShopTheCow()) {
            Request.getWebStore(this.props.params.splat, this.onWebStoreLoaded, this.loadError);
        } else {
            browserHistory.push('/'); // navigate to root
        }
    }

    onWebStoreLoaded = (webStoreData: Tgcc.WebStore) => {
        var filterList: string[];
        filterList = webStoreData.items.map(item => item.filter)
            .filter((value, index, self) => self.indexOf(value) === index);

        this.setState({
            filterList: filterList,
            webStore: webStoreData,
            isWaiting: false
        });
    }

    loadError = (err: any) => {
        var errMsg = "Store not available";
        if (err.message) {
            errMsg = err.message;
        }
        if (err.response && err.respons.text) {
            errMsg = JSON.parse(err.response.text).Message
        }
        this.setState({ error: errMsg, isWaiting: false });
        console.log("error loading web store: ", errMsg);
    }

    addToCart = (proofId: string) => {
        this.setState({ itemToAdd: proofId });
    }

    showCloseUp = (proofId: string) => {
        this.setState({ itemCloseUp: proofId });
    }

    cancelPopup = (evt: any) => {
        this.clearOperationState(evt);
    }

    clearOperationState = (evt: any) => {
        this.setState({ itemToAdd: null, showCart: false, showConfirmEmail: null, itemCloseUp: null });
    }

    getItem = (storeItem: Tgcc.WebStoreItem) => {
        if (storeItem && storeItem.tBanker && storeItem.tBanker.code)
            return <ShopCard key={storeItem.id}
                proofId={storeItem.tBanker.proofId}
                price={storeItem.tBanker.price}
                addCallback={this.addToCart}
                showCloseUp={this.showCloseUp} />

        return (<div></div>)
    }

    getStoreItems = () => {
        var items = [];
        if (this.state.webStore && this.state.webStore.items) {
            this.state.webStore.items.forEach((storeItem: Tgcc.WebStoreItem) => {
                if ((!this.state.activeFilter)
                    || (this.state.activeFilter && this.state.activeFilter == storeItem.filter))
                    items.push(this.getItem(storeItem));
            });
        }
        return items;
    }

    getStoreContent = () => {
        return (
            <div style={storeItemGroupStyle} key="itemlist" className="storeItemGroupStyle">
                {this.getStoreItems()}
            </div>
        );
    }

    getAddToCart = () => {
        if (this.state.itemToAdd && this.state.webStore && this.state.webStore.items) {
            var itemIndex = this.state.webStore.items.findIndex((item) => item.tBanker.proofId == this.state.itemToAdd);
            var item = this.state.webStore.items[itemIndex];
            if (item)
                return <ShopAddToCart
                    item={item}
                    cart={this.state.cart}
                    addCallback={this.addItemToCart}
                    goToCartCallback={this.gotoCart}
                    closeCallback={this.clearOperationState} />
        }
        return <div />
    }

    cartItemCount = () => {
        var total: number = 0;
        this.state.cart.items.forEach((item) => total += +item.quantity);
        return total;
    }

    addItemToCart = (item: Tgcc.WebStoreItem, qty: number, sz: string) => {
        var existingItem: Tgcc.WebStoreCartItem = null;
        this.state.cart.items.forEach((cartItem: Tgcc.WebStoreCartItem) => {
            if (cartItem.id == item.id && cartItem.size == sz)
                existingItem = cartItem;
        });

        var updatedCart = Object.assign({}, this.state.cart);

        if (existingItem) {
            existingItem.quantity = +existingItem.quantity + +qty;
        } else {
            var newCartItem: Tgcc.WebStoreCartItem = {
                id: item.id,
                quantity: +qty,
                size: sz,
                tBanker: item.tBanker
            }
            updatedCart.items.push(newCartItem);
        }

        this.setState({ cart: updatedCart, itemToAdd: null });
    }

    gotoCart = () => {
        if (this.state.cart.items.length > 0)
            this.setState({ showCart: true, itemToAdd: null });
    }

    getCartContent = () => {
        if (this.state.showCart) {
            return <ShopCart
                cart={this.state.cart}
                webStore={this.state.webStore}
                removeItemCallback={this.removeCartItem}
                changeQuantityCallback={this.changeCartItemQuantity}
                completeCheckout={this.completeCheckout}
                closeCartCallback={this.cancelPopup} />
        }
        return <div></div>// nothing
    }

    completeCheckout = (email: string) => {
        var cleanState = this.getEmptyState();
        cleanState.webStore = this.state.webStore;
        cleanState.showConfirmEmail = email;
        this.setState(cleanState);
    }

    changeCartItemQuantity = (id: number, size: string, qty: number) => {
        if (qty == 0) {
            this.removeCartItem(id, size);
        } else {
            var newCart: Tgcc.WebStoreCart = Object.assign({}, this.state.cart);
            newCart.items.forEach((item) => {
                if (item.id == id && item.size == size)
                    item.quantity = qty;
            });
            this.setState({ cart: newCart });
        }
    }

    removeCartItem = (id: number, size: string) => {
        var newCart: Tgcc.WebStoreCart = Object.assign({}, this.state.cart);
        var removeIndex: number = -1;
        newCart.items.forEach((item) => {
            if (item.id == id && item.size == size)
                removeIndex = this.state.cart.items.indexOf(item);
        });
        if (removeIndex > -1) {
            newCart.items.splice(removeIndex, 1);
            if (newCart.items.length < 1) {
                this.setState({ cart: newCart, showCart: null });
            } else {
                this.setState({ cart: newCart });
            }
        }
    }

    getCartButton = () => {
        return (<button style={storeTitleCartButtonStyle} id="storetitlecart" onClick={this.gotoCart}>
            <img src={cartImg} style={cartImageStyle} alt="shopping cart" />
            <div id="cartlabel" style={cartTextStyle}>Cart</div>
            {this.getCartBadge()}
        </button>)
    }

    getCartBadge = () => {
        var totalQty: number = this.cartItemCount();
        if (totalQty > 0) {
            return <div style={cartBadgeStyle}>{totalQty}</div>
        }
        return <div></div>
    }
    getHdrImg = () => {
        if(this.state.webStore.headerImg) {
            return Tgcc.ResolveUrl('~/images/') + this.state.webStore.headerImg;
        }
        return Tgcc.ResolveUrl('~/images/PrimaryLogo.svg');
    }
    onError  = (event: React.SyntheticEvent<HTMLImageElement>) => {
       event.currentTarget.style.display = '';
    }
    getLogoImg = () => {
        if(this.state.webStore.logo){
            return Tgcc.getMerchLogo(this.state.webStore.logo);
        }
    }
    getStoreHeader = () => {
        if (this.state.webStore) {
            return (
                <div style={storeHeaderStyle} id="storeheader">
                    <img style={storeLogo} className="storeLogo" src={this.getHdrImg()} />
                    <div style={storeCloseBannerStyle} id="storecloses">Custom store closing {this.state.webStore.closeDate}. Items will print and ship within 3 weeks of store closing date.</div>
                    <div style={storeTitleStyle} id="storetitle">
                        <div style={storeTitleLeftStyle}>
                            <img style={logoStyle} src={this.getLogoImg()} onError={this.onError}></img> <div style={storeTitleTextStyle} id="storetitletext" onClick={this.clearOperationState}>{this.state.webStore.title}</div>
                        </div>
                        <div style={storeTitleRightStyle}>
                            {this.getFilterLine()}
                            {this.getCartButton()}
                        </div>
                    </div>
                    <div style={storeDescriptionStyle} id="storedesc">{this.state.webStore.description}</div>
                </div >
            );
        }
        return (<div></div>)
    }

    getError = () => {
        if (this.state.error && !this.state.isWaiting) {
            return (<div>{this.state.error}</div>)
        }
        return (<div></div>)
    }

    startOver = (evt: any) => {
        var newstate = this.getEmptyState();
        newstate.webStore = this.state.webStore;
        this.setState(newstate);
    }

    getConfirmation = () => {
        if (this.state.showConfirmEmail)
            return <ShopConfirmation email={this.state.showConfirmEmail} clearStateCallback={this.startOver}></ShopConfirmation>
    }

    requestCloseUp = (proofId: string) => {
        this.setState({ itemCloseUp: proofId });
    }

    getCloseUp = () => {
        if (this.state.itemCloseUp)
            return <ShopItemCloseUp proofId={this.state.itemCloseUp} clearStateCallback={this.clearOperationState} />
        return <div></div>
    }

    getFilterOptions = () => {
        var values: Array<string> = [];
        var options: Array<any> = [];
        if (this.state.filterList && this.state.filterList.length > 1) {
            this.state.filterList.forEach((value: string, index: number) => values.push(value));
            values.sort();

            values.forEach((value: string, index: number) => {
                var key: string = "filterOption" + index;
                options.push(<option key={key}>{value}</option>);
            });
        }
        return options;
    }

    showAllValue = "Show all";

    onChangeFilter = (evt: any) => {
        var activeValue: string = evt.target.value;
        if (activeValue === this.showAllValue)
            this.setState({ activeFilter: undefined });
        else
            this.setState({ activeFilter: activeValue });
    }

    getFilterLine = () => {
        var options = this.getFilterOptions();

        if (options.length) {
            var label: string = this.state.webStore.filterPrompt ?? "Select filter";
            var activeValue: string = this.state.activeFilter ?? undefined;
            return (<div style={storeFilterBoxStyle} id="storeFilter" >
                <div style={storeFilterLabelStyle}>{label}</div>
                <select style={storeFilterSelectStyle} onChange={this.onChangeFilter} name="filterSelect" value={activeValue}>
                    <option>{this.showAllValue}</option>
                    {options}
                </select>
            </div>)
        }

        return <div></div>
    }

    getContent = () => {
        if (this.state.showCart)
            return this.getCartContent()

        return this.getStoreContent();
    }

    render() {
        var errorContent = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : <div style={Tgcc.Styles.error}>&nbsp;</div>
        return (
            <div key="storeouter" style={storeOuterStyle}>
                {this.getStoreHeader()}
                {this.getAddToCart()}
                {this.getConfirmation()}
                {this.getCloseUp()}
                <div key="storecontent" style={storeContentStyle} className="storeContent">
                    {errorContent}
                    {this.getContent()}
                </div>
            </div>);
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state };
};

